import axios from "@/request";
import qs from "qs";

export default {
  /* 审核日志 */
  async list(params: any) {
    return axios.get("invest-audit/list", { params });
  },
  /* 提交审核 */
  async submit(params: any) {
    return axios.post("invest-audit/submit", qs.stringify(params));
  },
}
